/**
 * Hint bot: core Greedy's pick, verified with a greedy playout; if that line loses, the first
 * other tappable tile whose playout wins is suggested. Used by the tutorial hand and test hooks.
 */
import { Greedy, Status, cloneRound, doTap, playGreedy, rngSeed, tappableTiles, type Round } from '@mp/core';

const SURE = { eps: 0, topK: 1 };

function playoutWins(r: Round, tile: number): boolean {
  const sim = cloneRound(r);
  doTap(sim, tile, sim.lastT + 100, null);
  if (sim.status === Status.Won) return true;
  if (sim.status !== Status.Playing) return false;
  playGreedy(sim, rngSeed(sim.taps, 'hint'), SURE);
  return (sim.status as Status) === Status.Won;
}

export function recommendTap(r: Round): number {
  if (r.status !== Status.Playing) return -1;
  const g = new Greedy(r.L.n, r.L.items.length);
  const first = g.choose(r, rngSeed(r.taps + 1, 'hint'), SURE);
  if (first < 0) return -1;
  const others = tappableTiles(r).filter((i) => i !== first);
  for (const c of [first, ...others].slice(0, 16)) if (playoutWins(r, c)) return c;
  return first;
}
